import { UserDoc } from "@megaron/docs-contracts";

import { toDisplayName } from "./displayName";

export type AssigneeRow = {
  email: string;
  fullName: string;
  roleLine: string;
  pictureUrl: string | null;
};

export function buildAssigneeRow(userDoc: UserDoc | undefined, email: string): AssigneeRow {
  const pictureUrl = userDoc?.profilePictureUrl ?? null;
  const firstName = userDoc?.firstName ?? null;
  const lastName = userDoc?.lastName ?? null;
  const nameParts = [firstName, lastName].filter((part): part is string => Boolean(part && part.trim()));
  const fullName =
    nameParts.length > 0 ? nameParts.join(" ") : toDisplayName(email.split("@")[0]);
  const roleLine =
    userDoc?.groups && userDoc.groups.length > 0
      ? userDoc.groups.map((g) => g.name).join(", ")
      : "–";
  return { email, fullName, roleLine, pictureUrl };
}
